module.exports = __webpack_public_path__ + "img/expostyle_0962_theatre_red_pantone7620c.a389a08b.jpg";